import React, {
  createContext,
  useCallback,
  useContext,
  useState,
} from 'react';

export const CommitteeListContext = createContext(
  {},
);

export const CommitteeListProvider = ({ children }) => {
  const [listOptions, setListOptions] = useState({
    filterParams: {
      committeeName: undefined,
      committeeStatus: undefined,
      frequency: undefined,
    },
    pagination: {
      page: 0,
      size: 5,
    },
  });

  const updateFilterParams = useCallback((params) => {
    setListOptions(oldValue => ({
      ...oldValue,
      filterParams: params
    }));
  }, []);

  const updatePagination = useCallback((paginationOption) => {
    setListOptions(oldValue => ({
      ...oldValue,
      pagination: paginationOption
    }));
  }, []);

  return (
    <CommitteeListContext.Provider
      value={{ listOptions, updateFilterParams, updatePagination }}
    >
      {children}
    </CommitteeListContext.Provider>
  );
};

export function useCommitteeList() {
  const context = useContext(CommitteeListContext);

  if (!context) {
    throw new Error('useCommitteeList must be used within an CommitteeListProvider.');
  }

  return context;
}
